//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// 如果sfkxg为1且为待审核数据，则显示“修改”，“撤销”，“查看详情”按钮
// 如果sfkxg为1且为审核通过数据，则显示“查看详情”按钮
// 如果sfkxg为0显示“查看详情”按钮
import {
  cancelEnroll,
  downloadEnrollTable,
} from '@/https/enroll'
import {
  danger,
  success,
} from '@/utils/notify.js'
import checkNoPassImg from '@/assets/img/check_no_pass.png'
import checkPassImg from '@/assets/img/check_pass.png'
import checkIngImg from '@/assets/img/check_ing.png'
import noSubmitImg from '@/assets/img/no_submit.png'
import { checkFilterTool } from '@/constant/dict.js'
import TCardItem from './TCardItem'

export default {
  components: { TCardItem },

  props: {
    list: {
      type: Array,
      default: () => ([]),
    },
  },

  data () {
    return {
      checkFilterTool,
      enrollList: [],
      wishNum: 0,
      statusMap: {
        '0': noSubmitImg,
        '1': checkIngImg,
        '2': checkPassImg,
        '3': checkNoPassImg,
      },
      msg: '没有查询到审核通过的报名信息',
    }
  },

  computed: {},

  watch: {
    list: {
      handler (val) {
        this.enrollList = val || []
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    goEnrollDetail (enroll) {
      this.$router.push({
        path: '/enrollDetail',
        query: {
          pcdm: enroll.pcdm,
          dzlbdm: enroll.dzlbdm,
        },
      })
    },

    async goEnrollTable (enroll) {
      const { data, code } = await downloadEnrollTable({ wid: enroll.ksWid })

      if (code === 0) {
        const a = document.createElement('a')

        a.setAttribute('href', data)
        a.click()
      }
    },

    async handlerRecycle (item) {
      const { code, message } = await cancelEnroll({ wid: item.ksWid })

      if (+code === 0) {
        this.$emit('reload')
        success('操作成功')
      } else {
        danger(message)
      }
    },

    handlerEnroll (enroll, type) {
      this.$router.push({
        path: '/enrollNotice',
        query: {
          pcdm: enroll.pcdm,
          dzlbdm: enroll.dzlbdm,
          jzsj: enroll.jzsj,
          type,
        },
      })
    },
  },
}
